import type { ConfiguratorOriginsType } from '@susu/custom-made/utils/constants';
import { ConfiguratorOrigin } from '@susu/custom-made/utils/constants';

const reloadPage = () => {
  //location.reload();
  const { origin, search } = location;
  let queryString = new URLSearchParams(search);
  queryString.delete('customError');

  let redirectUrl = new URL(`${origin}/custommade?${queryString}`);
  location.replace(redirectUrl);
};

const startFromScratch = () => {
  const { origin, search } = location;
  let queryString = new URLSearchParams(search);
  queryString.delete('configurationId');
  queryString.delete('origin');

  let redirectUrl = new URL(`${origin}/custommade?${queryString}`);
  location.replace(redirectUrl);
};

const redirectToReorderPage = () => {
  const { origin, search } = location;
  const redirectUrl = new URL(`${origin}/custommade${search}&reorder=true`);
  location.replace(redirectUrl);
};

const redirectToSearchPage = () => {
  const { origin, search } = location;
  const redirectUrl = new URL(`${origin}/custommade${search}&search=true`);
  location.replace(redirectUrl);
};

export type FetchError = {
  title: string;
  description: string;
  buttonText: string;
  handler: () => void;
};

export enum FetchErrors {
  None = 'None',
  General = 'General',
  ReorderNotFound = 'ReorderNotFound',
  SaveForLaterNotFoundShareCode = 'SaveForLaterNotFoundShareCode',
  SaveForLaterNotFoundConfigurationId = 'SaveForLaterNotFoundConfigurationId',
  FinishInStoreNotFoundShareCode = 'FinishInStoreNotFoundShareCode',
  FinishInStoreNotFoundConfigurationId = 'FinishInStoreNotFoundConfigurationId',
  CloneNotFound = 'CloneNotFound',
}

export type FetchErrorsType = keyof typeof FetchErrors;

const somethingWentWrongTitle = 'Something went wrong';
const somethingWentWrongDescription = 'Unfortunately, we’ve encountered an error. Please try again.';
const wrongConfigIdTitle = 'Wrong configuration ID';
const wrongConfigIdDescription = 'No configuration found with given configuration ID';
const wrongShareCodeTitle = 'Wrong share code';
const wrongShareCodeDescription = 'No configuration found with entered code';
const startAgainBtnText = 'Start again';
const tryAgainBtnText = 'Try Again';
const restartConfiguratorBtnText = 'Restart Configurator';

export const fetchErrors: { [key: string]: FetchError } = {
  General: {
    title: somethingWentWrongTitle,
    description: somethingWentWrongDescription,
    buttonText: startAgainBtnText,
    handler: reloadPage,
  },
  ReorderNotFound: {
    title: wrongConfigIdTitle,
    description: wrongConfigIdDescription,
    buttonText: tryAgainBtnText,
    handler: redirectToReorderPage,
  },
  SaveForLaterNotFoundShareCode: {
    title: wrongShareCodeTitle,
    description: wrongShareCodeDescription,
    buttonText: tryAgainBtnText,
    handler: redirectToSearchPage,
  },
  // Handler is different because this could happen only in onLine flow
  SaveForLaterNotFoundConfigurationId: {
    title: wrongConfigIdTitle,
    description: wrongConfigIdDescription,
    buttonText: tryAgainBtnText,
    handler: reloadPage,
  },
  FinishInStoreNotFoundShareCode: {
    title: wrongShareCodeTitle,
    description: wrongShareCodeDescription,
    buttonText: tryAgainBtnText,
    handler: redirectToSearchPage,
  },
  FinishInStoreNotFoundConfigurationId: {
    title: wrongConfigIdTitle,
    description: wrongConfigIdDescription,
    buttonText: tryAgainBtnText,
    handler: redirectToSearchPage,
  },
  CloneNotFound: {
    title: wrongConfigIdTitle,
    description: wrongConfigIdDescription,
    buttonText: restartConfiguratorBtnText,
    handler: startFromScratch,
  },
};

export const determineErrorType = (
  isNotFoundError: boolean,
  origin: ConfiguratorOriginsType,
  shareCode?: string,
): FetchErrorsType => {
  if (!isNotFoundError) {
    return FetchErrors.General;
  }

  switch (origin) {
    case ConfiguratorOrigin.FinishInStore:
      return shareCode ? FetchErrors.FinishInStoreNotFoundShareCode : FetchErrors.FinishInStoreNotFoundConfigurationId;
    case ConfiguratorOrigin.SaveForLater:
      return shareCode ? FetchErrors.SaveForLaterNotFoundShareCode : FetchErrors.SaveForLaterNotFoundConfigurationId;
    case ConfiguratorOrigin.Reorder:
      return FetchErrors.ReorderNotFound;
    case ConfiguratorOrigin.Clone:
      return FetchErrors.CloneNotFound;
    default:
      return FetchErrors.General;
  }
};
